export const userTypes = {
  SET_DATA: "USERS/SET_DATA",
  DELETE_USER: "USERS/DELETE_USER"
}

export function setUsersList(data) {
  return {
    type: userTypes.SET_DATA,
    payload: data
  }
}

export function deleteUserData(id) {
  return {
    type: userTypes.DELETE_USER,
    payload: id
  }
}
